<p-toast />
<p-toast key="update-available" />
<p-toast key="unrecoverable-state" />
<dk-global-loader />
<router-outlet></router-outlet>
<div class="d-none">
    <button pButton type="button" (click)="testSentryError()">Test Sentry Error</button>
</div>